import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, AlertTriangle, X } from "lucide-react";
import api from "@/lib/api";

/* Top banner shown across all app pages while the workspace is in trial. */
export default function TrialBanner() {
  const [sub, setSub] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get("/billing/trial")
      .then(({ data }) => { if (alive) setSub(data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!sub || dismissed) return null;
  if (sub.subscription_status === "active") return null;

  if (sub.subscription_status === "trial") {
    const d = sub.trial_days_remaining ?? 0;
    return (
      <div className="bg-[#0A0A0A] text-white px-4 py-2.5 flex items-center justify-between gap-3 text-xs sm:text-sm" data-testid="trial-banner">
        <div className="flex items-center gap-2 min-w-0">
          <Sparkles size={14} className="text-[#FF4F00] shrink-0" />
          <span className="truncate">
            <span className="font-medium">{d === 0 ? "Last day of your free trial." : `${d} ${d === 1 ? "day" : "days"} left in your free trial.`}</span>
            <span className="text-white/70 hidden sm:inline"> · Full access until then.</span>
          </span>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Link to="/billing/upgrade" data-testid="trial-banner-upgrade" className="inline-flex items-center gap-1.5 bg-[#FF4F00] hover:bg-white hover:text-[#0A0A0A] px-3 py-1.5 text-xs font-medium tracking-wide uppercase">
            Request a quote
          </Link>
          <button onClick={() => setDismissed(true)} className="opacity-60 hover:opacity-100" aria-label="Dismiss">
            <X size={14} />
          </button>
        </div>
      </div>
    );
  }

  // trial_expired
  return (
    <div className="bg-[#D90429] text-white px-4 py-2.5 flex items-center justify-between gap-3 text-xs sm:text-sm" data-testid="trial-expired-banner">
      <div className="flex items-center gap-2 min-w-0">
        <AlertTriangle size={14} className="shrink-0" />
        <span className="truncate font-medium">Your free trial has ended. Reads still work; writes are paused until you upgrade.</span>
      </div>
      <Link to="/billing/upgrade" data-testid="expired-banner-upgrade" className="inline-flex items-center gap-1.5 bg-white text-[#D90429] hover:bg-[#0A0A0A] hover:text-white px-3 py-1.5 text-xs font-medium tracking-wide uppercase shrink-0">
        Upgrade now
      </Link>
    </div>
  );
}
